<template>
  <div class="box">
    <img class="shareIMG" v-on:click="clickShare" v-if="this.$store.state.showShareCoupon" src="../assets/shareBack.png" alt="">
    <div class="back" v-on:click="back">
      <img src="../assets/GoBack.png" alt />
    </div>
    <!-- <div class="title">我的优惠卷</div> -->
    <yd-tab class="tab" v-model="MycouponIndex" :callback="fn">
      <yd-tab-panel label="当前有效">
        <div class="infinite-list-wrapper" style="overflow:auto;height:90vh">
          <ul class="list" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
            <li class="list-item" v-for="(item,index) in leftList" :key="index">
              <div class="shopList">
                <div class="shopName">
                  <div class="shopImg" v-on:click="toShopIndex(item)">
                    <img :src="CShttp+item.shop_icon_image" alt />
                  </div>
                  <div class="Name">
                    <div class="NameText" v-on:click="toShopIndex(item)">{{item.name}}</div>
                    <div class="shopInfo">
                      <div  v-on:click="toShopIndex(item)">
                        <span>{{item.shop_class_list}}</span>
                        <span class="shopInfoCenter">|</span>
                        <span>月销量{{item.xiaoliang?item.xiaoliang:0}}</span>
                      </div>
                      <router-link
                        :to="{ name: 'mapLocation', query: { endLocation: {lng: item.longitude, lat: item.latitude }}}"
                      >
                        <div style="display: flex;justify-content: center;align-items: flex-end;"> <img style="width:0.4rem" src="../assets/map02.png" alt />{{(item.juli/1000).toFixed(2)}}km</div>
                      </router-link>
                    </div>
                  </div>
                </div>
                <div class="couponList">
                  <div v-for="(coupon,idxs) in item.coupon_list" :key="idxs">
                    <MycouponList
                      class="animated bounceIn"
                      :IconImg="item.shop_icon_image"
                      :CouponInfo="coupon"
                      type="Mycoupon"
                      :MycouponIndex="MycouponIndex"
                    ></MycouponList>
                  </div>
                </div>
                <div class="packUp" data-id="0" v-on:click="packUp">
                  点击收起优惠卷
                  <img src="../assets/top.png" data-id="0" alt />
                </div>
                <div class="sentOut" style="display:none" data-id="1" v-on:click="packUp">
                  点击展示优惠卷
                  <img src="../assets/bottom.png" data-id="1" alt />
                </div>
              </div>
            </li>
            <li
              v-if="leftList.length==0"
              style="padding-top:0.3rem;width:100%;text-align:center"
            >暂无数据</li>
          </ul>
          <p v-if="loading">加载中...</p>
          <p v-if="noMore">没有更多了</p>
        </div>
      </yd-tab-panel>
      <yd-tab-panel label="已使用">
        <div class="infinite-list-wrapper" style="overflow:auto;height:90vh">
          <ul class="list" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
            <li class="list-item" v-for="(item,index) in centerList" :key="index">
              <div class="shopList">
                <div class="shopName">
                  <div class="shopImg">
                    <img :src="CShttp+item.shop_icon_image" alt />
                  </div>
                  <div class="Name">
                    <div class="NameText">{{item.name}}</div>
                    <div class="shopInfo">
                      <div>
                        <span>{{item.shop_class_list}}</span>
                        <span class="shopInfoCenter">|</span>
                        <span>月销量{{item.xiaoliang?item.xiaoliang:0}}</span>
                      </div>
                      <div>{{(item.juli/1000).toFixed(2)}}km</div>
                    </div>
                  </div>
                </div>
                <div class="couponList">
                  <div v-for="(coupon,idxs) in item.coupon_list" :key="idxs">
                    <MycouponList
                      class="animated bounceIn"
                      :IconImg="item.shop_icon_image"
                      :CouponInfo="coupon"
                      type="Mycoupon"
                      :MycouponIndex="MycouponIndex"
                    ></MycouponList>
                  </div>
                </div>
                <div class="packUp" data-id="0" v-on:click="packUp">
                  点击收起优惠卷
                  <img src="../assets/top.png" data-id="0" alt />
                </div>
                <div class="sentOut" style="display:none" data-id="1" v-on:click="packUp">
                  点击展示优惠卷
                  <img src="../assets/bottom.png" data-id="1" alt />
                </div>
              </div>
            </li>
            <li
              v-if="centerList.length==0"
              style="padding-top:0.3rem;width:100%;text-align:center"
            >暂无数据</li>
          </ul>
          <p v-if="loading">加载中...</p>
          <p v-if="noMore">没有更多了</p>
        </div>
      </yd-tab-panel>
      <yd-tab-panel label="已失效">
        <div class="infinite-list-wrapper" style="overflow:auto;height:90vh">
          <ul class="list" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
            <li class="list-item" v-for="(item,index) in rightList" :key="index">
              <div class="shopList">
                <div class="shopName">
                  <div class="shopImg">
                    <img :src="CShttp+item.shop_icon_image" alt />
                  </div>
                  <div class="Name">
                    <div class="NameText">{{item.name}}</div>
                    <div class="shopInfo">
                      <div>
                        <span>{{item.shop_class_list}}</span>
                        <span class="shopInfoCenter">|</span>
                        <span>月销量{{item.xiaoliang?item.xiaoliang:0}}</span>
                      </div>
                      <div>{{(item.juli/1000).toFixed(2)}}km</div>
                    </div>
                  </div>
                </div>
                <div class="couponList">
                  <div v-for="(coupon,idxs) in item.coupon_list" :key="idxs">
                    <MycouponList
                      class="animated bounceIn"
                      :IconImg="item.shop_icon_image"
                      :CouponInfo="coupon"
                      type="Mycoupon"
                      :MycouponIndex="MycouponIndex"
                    ></MycouponList>
                  </div>
                </div>
                <div class="packUp" data-id="0" v-on:click="packUp">
                  点击收起优惠卷
                  <img src="../assets/top.png" data-id="0" alt />
                </div>
                <div class="sentOut" style="display:none" data-id="1" v-on:click="packUp">
                  点击展示优惠卷
                  <img src="../assets/bottom.png" data-id="1" alt />
                </div>
              </div>
            </li>
            <li
              v-if="rightList.length==0"
              style="padding-top:0.3rem;width:100%;text-align:center"
            >暂无数据</li>
          </ul>
          <p v-if="loading">加载中...</p>
          <p v-if="noMore">没有更多了</p>
        </div>
      </yd-tab-panel>
    </yd-tab>
  </div>
</template>

<script>
import MycouponList from "../components/MycouponList";
import $ from "jquery";
export default {
  name: "",
  data() {
    return {
      CShttp: this.$store.state.CShttp,
      MycouponIndex: 0,
      page: 1,
      pageSize: 10,
      loading: false,
      status: 1,
      leftList: [],
      rightList: [],
      centerList: [],
      showShareIMG:false
    };
  },
  components: {
    MycouponList
  },
  computed: {
    noMore() {
      return this.count >= 20;
    },
    disabled() {
      return this.loading;
    }
  },
  created() {},
  mounted() {
    var openid = localStorage.getItem("ZQopenid");
    var UserInfo = localStorage.getItem("ZQUserInfo")
      ? JSON.parse(localStorage.getItem("ZQUserInfo"))
      : "";
    var location = JSON.parse(localStorage.getItem("ZQlocation"));
    this.$store.commit("location", location);
    this.$store.commit("UserInfo", {
      UserInfo: UserInfo
    });
    this.$store.commit(
      "UserSelf",
      JSON.parse(localStorage.getItem("ZQUserSelf"))
    );
    this.UserInfo = UserInfo;
    this.openid = UserInfo.openid;
    this.GetMyCoupon();
  },
  methods: {
    clickShare(){
      this.$store.commit("showShareCoupon", false);
    },
    showshareimg(a){
      this.showShareIMG=a
    },
    //跳转商品详情页
    toShopIndex(item) {
      this.$router.push({ path: "/shopIndex", query: { id: item.id } });
    },
    load() {
      console.log("上拉加载");
    },
    back() {
      this.$router.go(-1);
    },
    fn(label, key) {
      console.log(label, key);
      if (label == "当前有效") {
        this.status = 1;
        this.GetMyCoupon();
      }
      if (label == "已失效") {
        this.status = 2;
        this.GetMyCoupon();
      }
      if (label == "已使用") {
        this.GetMyUseCoupon();
      }
      this.MycouponIndex = key;
    },
    packUp(e) {
      console.log(e);
      var id = e.target.dataset.id;
      $(e.target)
        .parents(".shopList")
        .children(id == 0 ? ".packUp" : ".sentOut")
        .css({
          display: "none"
        })
        .parents(".shopList")
        .children(".couponList")
        .css({
          display: id == 0 ? "none" : "block"
        });
      $(e.target)
        .parents(".shopList")
        .children(id == 0 ? ".sentOut" : ".packUp")
        .css({
          display: "flex"
        });
    },
    //获取优惠券
    GetMyCoupon() {
      if (!this.$store.state.loading) {
        this.$store.commit("showLoading", true); //显示加载图标
        this.$http
          .get("/api/coupon/is_effective", {
            params: {
              uid: this.$store.state.useId,
              status: this.status,
              log: this.$store.state.log,
              lat: this.$store.state.lat
            }
          })
          .then(res => {
            console.log(res.data);
            var list = res.data.data ? res.data.data.action : "";
            if (list) {
              if (this.status == 1) {
                this.leftList = [];
              }
              if (this.status == 2) {
                this.rightList = [];
              }
              list.map(item => {
                console.log(item);
                for (var i = 0; i < item.coupon_list.length; i++) {
                  item.coupon_list[i].shop_info = { name: item.name };
                }
                if (this.status == 1) {
                  this.leftList.push(item);
                }
                if (this.status == 2) {
                  this.rightList.push(item);
                }
              });
            }
            this.$store.commit("showLoading", false); //隐藏加载图标
          });
      }
    },
    //获取已使用优惠券
    GetMyUseCoupon() {
      this.$store.commit("showLoading", true); //显示加载图标
      this.$http
        .get("/api/coupon/user_is_use", {
          params: {
            uid: this.$store.state.useId,
            log: this.$store.state.log,
            lat: this.$store.state.lat
          }
        })
        .then(res => {
          console.log(res.data);
          this.centerList = [];
          var list = res.data.data ? res.data.data.action : "";
          if (list) {
            list.map(item => {
              for (var i = 0; i < item.coupon_list.length; i++) {
                item.coupon_list[i].shop_info = { name: item.name };
              }
              this.centerList.push(item);
            });
          }
          this.$store.commit("showLoading", false); //隐藏加载图标
        });
    }
  }
};
</script>
<style lang='scss' scoped>
.box {
  width: 7.5rem;
  height: 100vh;
  background: white;
}
.shareIMG{
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10000;
}
.shopAttentionList {
  background: white;
  height: 100vh;
  position: relative;
  height: 90vh;
}
.title {
  font-size: 0.32rem;
  line-height: 0.9rem;
  text-align: center;
  border-bottom: 1px solid #e5e5e5;
}
.back {
  position: absolute;
  top: 0.2rem;
  left: 0.2rem;
  width: 0.4rem;
  height: 0.4rem;
  z-index: 1000;
}
.back img {
  width: 100%;
  height: 100%;
  display: inline-block;
}
.tab {
  width: 7.5rem;
}
.shopList {
  margin: 0.3rem 0.25rem 0 0.25rem;
  padding: 0.35rem 0.15rem;
  padding-bottom: 0;
  background: #f5f5f5;
  border-radius: 0.2rem;
}
//商店表头
.shopName {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 0 0.3rem;
}
.shopName > .shopImg {
  width: 0.9rem;
  height: 0.9rem;
  border-radius: 100%;
  overflow: hidden;
  flex-shrink: 0;
  z-index: 100;
}
.shopImg > img {
  width: 0.9rem;
  height: 0.9rem;
  flex-shrink: 0;
}
.Name {
  width: 100%;
  margin-left: 0.3rem;
  position: relative;
}
.NameText {
  margin-top: 0.1rem;
  font-size: 0.26rem;
  line-height: 0.4rem;
}
.shopInfo {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.24rem;
  color: #636363;
}
.shopInfoCenter {
  display: inline-block;
  margin: 0 0.2rem;
}
// 、、、、
.packUp,
.sentOut {
  width: 100%;
  color: #cd160d;
  font-size: 0.26rem;
  text-align: center;
  line-height: 0.9rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.packUp img,
.sentOut img {
  width: 0.4rem;
  height: 0.4rem;
}
</style>
